

































// @ is an alias to /src
import { AloPlat, getDefaultAloPlat } from '@/models/alo/AloPlat'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {ItemPanier} from '@/models/alo/ItemPanier'
import { VuetifyConfirmObject } from 'node_modules/vuetify-confirm/types'
import { getDefaultAloArbo } from '@/models/alo/AloArbo'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'
import MenuBreakfastSectionItem from '@/components/carte/MenuBreakfastSectionItem.vue'

@Component({
  name: 'MenuBreakfastSection',  
  props: {
    show:{
      type:Boolean,
      default:false
    },
    value:{
      type:Array,
      default: () => []
    }
  },components:{MenuBreakfastSectionItem}
})
export default class MenuBreakfastSection extends mixins(BasePlat) {    
  show!:boolean  
  value!:Array<ItemPanier>

  get showDialog(){
    return this.show
  }

  set showDialog(value) {
    this.$emit("update:show",value)
  } 

  get section(){
    return this.arbosDic[this.plat.arboId!] || getDefaultAloArbo()
  }
  
  get platsDic(){    
    return this.$store.myGetters.platsDic
  }

  get showAllergene(){
    return this.$store.myGetters.showAllergene
  }

  set showAllergene(value) {
    this.$store.myActions.UI_SET_ALLERGENE_VISIBLITY(value)
  }

  get plats() {
    return this.section.platsIds?.map(id => this.platsDic[id]) || []
  }

  get qtySectionSelected() {
    return this.value.reduce((total,item) => total + item.qty,0)
  }

  get nbChoixSectionRestant() {    
    return (this.plat.qty || 0) - this.qtySectionSelected;    
  }

  @Watch("nbChoixSectionRestant")
  onNbChoixSectionRestant(restant:number) {
    //this.tryAutoClose()
  }

  tryAutoClose(){
    if(this.nbChoixSectionRestant == 0) {
      this.showDialog = false;      
    }
  }

  get titleOption(){
    return `${this.nbChoixSectionRestant} choix restant${this.nbChoixSectionRestant>1?'s':''}`
  }

   get showAllergeneBtn() {
    return !this.printMode && this.plats.some(p => this.hasAllergene(p))
  }

  hasAllergene(plat:AloPlat):boolean {
    return (plat.allergenesIds && plat.allergenesIds.length > 0) || (plat.platsIds?.map(id => this.platsDic[id]) || []).some(p => this.hasAllergene(p))  
  }

}
